var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8989 2.24231H7.64893V5.36731H13.8989V2.24231Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8989 3.49231H16.3989C16.5647 3.49231 16.7237 3.55816 16.8409 3.67537C16.9581 3.79258 17.0239 3.95155 17.0239 4.11731V17.2423C17.0239 17.4081 16.9581 17.567 16.8409 17.6843C16.7237 17.8015 16.5647 17.8673 16.3989 17.8673H5.14893C4.98317 17.8673 4.82419 17.8015 4.70698 17.6843C4.58977 17.567 4.52393 17.4081 4.52393 17.2423V4.11731C4.52393 3.95155 4.58977 3.79258 4.70698 3.67537C4.82419 3.55816 4.98317 3.49231 5.14893 3.49231H7.64893",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrial);
export default __webpack_public_path__ + "static/media/Trial.7d1e3d56368c1affbfebfb548b347477.svg";
export { ForwardRef as ReactComponent };